export const DEFAULT_VALUE_TEMPLATES_TYPE_ITEM = { list: [] };
